import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
import { ParametroAutonomia } from './parametro-autonomia.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ParametroAutonomiaService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private insertarParametroAutonomiaUrl: string = 'parametroAutonomia/insertar';
  private actualizarParametroAutonomiaUrl: string = 'parametroAutonomia/actualizar';
  private obtenerParametroAutonomiaUrl: string = 'parametroAutonomia/obtener';
  private listarParametroAutonomiaPorUrl: string = 'parametroAutonomia/listarPor';

  insertarParametroAutonomia(parametroAutonomia: ParametroAutonomia): any {
    let parameters: string;
    parameters = JSON.stringify({
      nombre: parametroAutonomia.nombre,
      userCreation: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.insertarParametroAutonomiaUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarParametroAutonomia(parametroAutonomia: ParametroAutonomia): any {
    let parameters: string;
    parameters = JSON.stringify({
      id: parametroAutonomia.id,
      nombre: parametroAutonomia.nombre,
      userLastUpdate: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.actualizarParametroAutonomiaUrl);
    return this.dataService.execPostJson(parameters);
  }

  obtenerParametroAutonomia(id: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(id));
    this.dataService.set(this.obtenerParametroAutonomiaUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarParametroAutonomia(filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    this.dataService.set(this.listarParametroAutonomiaPorUrl);
    return this.dataService.execGetJson(parameters);
  }
}
